export const yesOrNot = [
  {
    label: 'Não',
    value: '0',
  },
  {
    label: 'Sim',
    value: '1',
  },
]
